var React = require('react');

function WindowsLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.4462 0H0V11.4462H11.4462V0ZM11.4462 12.5538H0V24H11.4462V12.5538ZM12.5539 12.5538H24V24H12.5539V12.5538ZM24 0H12.5539V11.4462H24V0Z","fill":"#202C46"}));
}

WindowsLogo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = WindowsLogo;

WindowsLogo.default = WindowsLogo;
